// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"017c891a","455":"038e00a9","977":"1215fd05"}[chunkId] + ".chunk.js";
};